var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"tree__item",class:{
    'tree__item--loading': _vm.application._.loading,
  }},[_c('div',{staticClass:"tree__action",class:{ 'tree__action--highlighted': _vm.application._.selected }},[_c('a',{staticClass:"tree__link",on:{"click":function($event){return _vm.selectDashboard(_vm.application)}}},[_c('i',{staticClass:"tree__icon",class:_vm.application._.type.iconClass}),_vm._v(" "),_c('span',{staticClass:"tree__link-text"},[_vm._v(_vm._s(_vm.application.name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }